import StoriesContainer from './Stories';
import reducer from './stories.reducer';

/**
 * Stories module exports
 */
export {
    StoriesContainer as default,
    reducer,
};



// WEBPACK FOOTER //
// ./src/js/Stories/index.js